import React from 'react';
import EvaluatorAssignmentItem from './EvaluatorAssignmentItem';
import CountryText from '../Elements/CountryText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import LongText from '../Elements/LongText';

export default class ExcludedPayEvaluatorsItem extends EvaluatorAssignmentItem {
  static clickOnGlobalSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static clickOnSelect(item, selected) {
    // Placeholder, don't remove it!
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellContent(item) {
    return (
      <input
        type='checkbox'
        checked={item.Selected}
        onChange={(e) => {
          ExcludedPayEvaluatorsItem.clickOnSelect(item, e.target.checked);
        }}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <input
        type='checkbox'
        checked={ExcludedPayEvaluatorsItem.selectedStatus()}
        onChange={(e) => {
          ExcludedPayEvaluatorsItem.clickOnGlobalSelect(item, e.target.checked);
        }}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: ExcludedPayEvaluatorsItem.getSelectedCellHeader,
        orderById: '',
        data: ExcludedPayEvaluatorsItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Apollo Job ID',
        orderById: 'AsSassieAsgnId',
        data: EvaluatorAssignmentItem.idFunction,
        minWidth: '80px',
      },
      { label: 'Client', orderById: 'ClientName', data: 'ClientName', minWidth: 50 },
      {
        label: 'Project',
        orderById: 'AsCfid',
        data: (item) => (
          <LongText
            text={item.ProjectIdAndName}
            maxLength={30}
          />
        ),
        minWidth: 100,
      },
      { label: 'Location', orderById: 'CuName', data: 'CuName', minWidth: 50 },
      { label: 'Eval Fee', orderById: 'AsIeFee', data: 'AsIeFee', minWidth: 50 },
      { label: 'Eval Addit. Fee', orderById: 'AsIeFeeAdjustment', data: 'AsIeFeeAdjustment', minWidth: 50 },
      { label: 'Eval Reimb.', orderById: 'AsIeReimbursement', data: 'AsIeReimbursement', minWidth: 50 },
      { label: 'Eval Travel', orderById: 'AsIeTravel', data: 'AsIeTravel', minWidth: 50 },
      { label: 'Eval Gaming', orderById: 'AsIeGaming', data: 'AsIeGaming', minWidth: 50 },
      { label: 'Eval Misc', orderById: 'AsIeMisc', data: 'AsIeMisc', minWidth: 50 },
      { label: 'FW Office', orderById: 'AsLdvname', data: 'AsLdvname' },
      { label: 'FW Fee', orderById: 'InFieldworkFee', data: 'InFieldworkFee', minWidth: 50 },
      { label: 'Evaluator', orderById: 'AsEvname', data: 'AsEvname', minWidth: 50 },
      { label: 'Status', orderById: 'LgsDesc', data: 'LgsDesc', minWidth: 60 },
      {
        label: 'Completed On',
        orderById: 'AsEvaluatorCompletedDateFormatted',
        data: 'AsEvaluatorCompletedDateFormatted',
      },
      { label: 'Country', orderById: 'CuCountry', data: (item) => <CountryText Code={item.CuCountry} />, minWidth: 50 },
      {
        label: 'Uninvoiceable',
        orderById: 'AsUninvoiceable',
        // EvaluatorAssignmentItem stores the flag as the text 'True'/'False', so negating it was always false.
        data: (item) => EvaluatorAssignmentItem.badgeFunction(item.AsUninvoiceable === 'True'),
        minWidth: 20,
      },
    ];
  }
}
